import { LargeSiteScreenNewRunModal } from "@/tools/risk-bands/large-site-screen/components/LargeSiteScreenNewRunModal";
import { useLssTutorialState } from "@/tools/risk-bands/large-site-screen/context/LssTutorialContext";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Header for the Portfolio Export tool's table.
 */
export const LargeSiteScreenTableHeader = ({
  actionBtns
}: any) => {
  const router = useRouter();
  const {
    startNewRunBtn,
    libraryFilters,
    registerCloseReviewModal,
    registerOpenReviewModal
  } = useLssTutorialState();
  const [isModalOpen, setIsModalOpen] = useState(Object.keys(router.query).includes("handoff"));
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "comprehensive.largeSite"
  });
  const handleModalClose = () => {
    setIsModalOpen(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {
      handoff,
      ...queryWithoutHandoff
    } = router.query; //exclude handoff from path if analysis modal is closed
    router.replace({
      pathname: router.pathname,
      query: queryWithoutHandoff
    }, undefined, {
      shallow: true
    });
  };
  useEffect(() => {
    registerCloseReviewModal(handleModalClose);
  });
  useEffect(() => {
    registerOpenReviewModal(() => setIsModalOpen(true));
  });
  return <>
      <div className="flex w-full items-center justify-between pb-4">
        <div ref={libraryFilters} className="flex w-full items-center justify-start gap-2">
          {actionBtns}
        </div>
        <div className="flex w-full items-center justify-end gap-2">
          <div ref={startNewRunBtn}>
            <Link href="/tools/create/lss-from-map" passHref data-sentry-element="Link" data-sentry-source-file="LargeSiteScreenTableHeader.tsx">
              <Button type="primary" icon={<PlusOutlined />} data-sentry-element="Button" data-sentry-source-file="LargeSiteScreenTableHeader.tsx">
                {t("startNewRun")}
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <LargeSiteScreenNewRunModal open={isModalOpen} onCancel={handleModalClose} onRunStart={handleModalClose} data-sentry-element="LargeSiteScreenNewRunModal" data-sentry-source-file="LargeSiteScreenTableHeader.tsx" />
    </>;
};